import { render } from "./VLoader.vue?vue&type=template&id=99d96100"
const script = {}

import "./VLoader.vue?vue&type=style&index=0&id=99d96100&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__